import type { ForwardedRef } from "react";
import React, { forwardRef, memo } from "react";
import clsx from "clsx";
import Navigation from "./Navigation";
import Cta from "./Cta";
import GradeSwitch from "./GradeSwitch";
import BackButton from "./BackButton";
import Container from "../../../../../shared-components/css-modules/toyota/atoms/Container";
import styles from "./Header.module.scss";
import type { CarConfigStep } from "../../../../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { useCarConfigSelector } from "../../../../redux/store";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import a11y from "../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import { CarConfigLabel } from "../../../../utils/labelUtils";

type HeaderType = {
    activeStep: CarConfigStep;
};

const Header = (props: HeaderType, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const { activeStep } = props;
    const hideSidebar = useCarConfigSelector((state) => state.carConfigSettings.hideSidebar);

    return (
        // Id used for size calculation
        <header className={styles.header} data-step={activeStep} id="or-apheleia-header" ref={ref}>
            <Container className={styles["header-container"]}>
                <div className={styles["header-grid"]}>
                    <div className={styles.selector}>
                        <div className={styles.gradeswitch}>
                            <GradeSwitch />
                        </div>
                        <Navigation activeStep={activeStep} />
                    </div>
                    <div className={styles.cta}>
                        <Cta />
                    </div>
                </div>
            </Container>

            <div className={clsx(styles["back-bar"], hideSidebar && styles.full)}>
                <Container>
                    <BackButton />
                </Container>
            </div>
            <Button
                variant="btn-default"
                href="#step-navigation"
                className={clsx(a11y["skip-to-content"], styles.skip)}
            >
                <CarConfigLabel label="ariaSkipToAnchorsNavigation" />
            </Button>
        </header>
    );
};

export default memo(forwardRef(Header));
